<template>
  <svg
    style="overflow: visible"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    @mousedown="mousedown"
  >
    <g
      class="marble"
      :transform="`translate(${time}, 5)`"
      :style="{
        cursor: isHighlighted ? 'ew-resize' : 'default'
      }"
    >
      <circle
        r="2.3"
        :style="circleStyle"
      ></circle>
      <text
        text-anchor="middle"
        y="0.8"
        :style="textStyle"
      >
        {{ props.content }}
      </text>
    </g>

    <filter
      id="#dropshadow"
      height="130%"
    >
      <feGaussianBlur
        in="SourceAlpha"
        stdDeviation="0.3"
      ></feGaussianBlur>
      <feOffset
        dx="0"
        dy="0.25"
        result="offsetblur"
      ></feOffset>
      <feFlood flood-color="rgba(0,0,0,0.4)"></feFlood>
      <feComposite
        in2="offsetblur"
        operator="in"
      ></feComposite>
      <feMerge>
        <feMergeNode></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
  </svg>
</template>

<script setup lang="ts">
import { ref, watch, onUnmounted, onMounted } from "vue";
import { getPercentageFn, changedMarbleSubject$ } from "./rxMarble";
import { POSSIBLE_COLORS, STROKE_WIDTH, fontBase } from "./styles";

const props = defineProps<{
  marbleID: number;
  time: number;
  isInteractive: boolean;
  content: number | string;
}>();

const time = ref<number>(props.time);

watch(
  () => props.time,
  (t) => {
    time.value = t;
  }
);

const isHighlighted = ref<boolean>(false);
const isDraggable = ref<boolean>(false);

const mouseenter = () => {
  if (!props.isInteractive) return;
  isHighlighted.value = true;
};

const mouseleave = () => {
  if (!props.isInteractive) return;
  isHighlighted.value = false;
};

let parentElement: HTMLElement;
const mousedown = (e: MouseEvent) => {
  if (!props.isInteractive) return;

  isDraggable.value = true;
  parentElement = (e.currentTarget as HTMLElement).parentElement!;
};

function moveMarble(e: MouseEvent) {
  if (!props.isInteractive) return;
  if (isDraggable.value) {
    time.value = getPercentageFn(parentElement)(e.pageX);
    changedMarbleSubject$.next({ marbleID: props.marbleID, time: time.value });
  }
}

function mouseUp(e: MouseEvent) {
  if (!props.isInteractive) return;
  isDraggable.value = false;
}

const circleStyle = ref<Record<string, any>>();
watch(
  isHighlighted,
  () => {
    circleStyle.value = Object.assign(
      {
        fill: POSSIBLE_COLORS[props.marbleID % POSSIBLE_COLORS.length],
        stroke: "black",
        strokeWidth: STROKE_WIDTH
      },
      isHighlighted.value ? { filter: "url(#dropshadow)" } : {}
    );
    console.log(circleStyle.value);
  },
  { immediate: true }
);

const textStyle = Object.assign({ fontSize: "2.5px" }, fontBase);

onMounted(() => {
  document.addEventListener("mousemove", moveMarble);
  document.addEventListener("mouseup", mouseUp);
});

onUnmounted(() => {
  document.removeEventListener("mousemove", moveMarble);
  document.removeEventListener("mouseup", mouseUp);
});
</script>
